export default function Arrow({ ...props }) {
  return (
    <svg viewBox="0 0 20.85 17.655" {...props}>
      <g fill="none">
        <path d="M.5 8.827h19.85" />
        <path d="m12.229.707 8.12 8.12-8.12 8.121" />
      </g>
    </svg>
  );
}
